<template>
  <div class="nav-container" :style="{ height: heightt }">
    <aside class="sidebar">
      <!-- 一级菜单 -->
      <ul>
        <li v-if="parentList.length > 0" v-for="item in parentList" :key="item.id" @click="handleParentClick(item.id)"
          :class="{ 'active-class': item.id == parentId }">
          {{ item.mediaTitle }}
        </li>
        <li v-else>暂无数据</li>
      </ul>
    </aside>
    <main class="content">
      <!-- 二级菜单 -->
      <div class="childmain">
        <div class="parentName">{{ parentName }}</div>
        <div class="childlist" v-if="childList.length > 0" v-for="item in childList" :key="item.id"
          @click="jumpByUrl(item.path, item.label)">
          <!-- <div><img :src="require('@/assets/images/huaHouMedia.jpg')" alt="Thumbnail" /></div> -->
          <div><img :src="getImageUrl(item.imgUrl)" alt="Thumbnail" /></div>
          <!-- item.imgUrl -->
          <div>{{ item.label }}</div>
        </div>
        <div v-else>暂无数据</div>
      </div>
    </main>
  </div>
</template>

<script setup>
import axios from 'axios'
import { defineProps, ref, onMounted, computed } from "vue";
import { ElMessage, ElMessageBox, ElDivider } from "element-plus";
// 定义接收的 props
const props = defineProps({
  heightt: {
    type: String,
    required: true,
  },
});

const menus = ref([]);

const parentId = ref(Number);
const parentName = ref("");
const parentList = ref([]);
const childList = ref([]);

const getImageUrl = (imgUrl) => {
  return require(`@/assets/images/${imgUrl}`);
}

const handleParentClick = (id) => {
  if (id) {
    const parentRow = menus.value.find((item, i) => {
      return item.id == id;
    });
    if (parentRow.id) {
      parentName.value = parentRow.mediaTitle;
      parentId.value = parentRow.id;
      childList.value = parentRow.mediaList;
    }
  }
};

const getMenus = async () => {
  try {
    const timestamp = Date.now();
    const response = await axios.get('/api/getMenuList', {
      params: { _: timestamp },
      headers: {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache'
      },
      responseType: 'json',
      transformRequest: [(data, headers) => {
        delete headers['If-Modified-Since'];
        delete headers['If-None-Match'];
        return data;
      }]
    });

    if (response.data.code === 200) {
      menus.value = response.data.data;
    }
  } catch (error) {
    console.error('请求数据失败:', error);
  }
};

const getparentMenu = async () => {
  parentList.value = menus.value;
  if (parentList.value.length > 0) {
    const id = parentList.value[0].id;
    const parentRow = parentList.value.find((item, i) => {
      return item.id == id;
    });
    parentName.value = parentRow.mediaTitle;
    parentId.value = parentRow.id;
    childList.value = parentRow.mediaList;
  }
};

const jumpByUrl = (url, label) => {
  console.log(url, label);
  // window.open(url, "_blank");
  window.location.href = url;
};

onMounted(async () => {
  console.log("window.innerHeight:" + window.innerHeight);
  await getMenus();
  await getparentMenu();
});
</script>

<style scoped>
.nav-container {
  display: flex;
  overflow: hidden;
  position: relative;
  background: #ffffff;
  border-radius: 10px;
  margin: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  height: auto !important;
  min-height: 0;
}

.sidebar {
  width: 38%;
  max-width: 200px;
  background: #f7f9fc;
  overflow-y: auto;
  height: 100%;
  scroll-behavior: smooth;
  border-right: 1px solid #eef1f6;
}

.sidebar ul {
  list-style: none;
  padding: 10px 8px;
  margin: 0;
}

.sidebar ul li {
  padding: 12px 10px;
  margin-bottom: 4px;
  cursor: pointer;
  transition: all 0.25s;
  overflow-wrap: break-word;
  border-radius: 8px;
  font-size: 14px;
  color: #444;
  line-height: 1.5;
}

.sidebar ul li:hover {
  background: #ecf5ff;
  color: #1a73e8;
}

.active-class {
  background: linear-gradient(135deg, #409eff, #66b1ff);
  color: #fff !important;
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.35);
}

.content {
  flex: 1;
  overflow-y: auto;
  height: 100%;
  padding: 14px;
  background: #ffffff;
}

.childmain {
  min-height: min-content;
}

.childmain .parentName {
  color: #1a73e8;
  padding: 0 0 10px 10px;
  border-bottom: 1px solid #eef1f6;
  font-size: 16px;
  font-weight: 600;
  position: relative;
}

.childmain .parentName::before {
  content: "";
  position: absolute;
  left: 0;
  top: 3px;
  width: 4px;
  height: 15px;
  border-radius: 2px;
  background: linear-gradient(180deg, #409eff, #66b1ff);
}

.childlist {
  display: flex;
  align-items: center;
  border-bottom: none;
  background: #f9fbfe;
  border: 1px solid #eef3fa;
  border-radius: 8px;
  margin: 8px 0;
  padding: 8px;
  transition: all 0.2s;
  cursor: pointer;
}

.childlist:hover {
  background: #ecf5ff;
  border-color: #b3d8ff;
  box-shadow: 0 2px 10px rgba(64, 158, 255, 0.15);
  transform: translateY(-1px);
}

.childlist div:nth-child(1) {
  width: 56px;
  flex-shrink: 0;
  padding: 0;
}

.childlist div:nth-child(1) img {
  width: 100%;
  border-radius: 6px;
  display: block;
}

.childlist div:nth-child(2) {
  width: 100%;
  padding: 2px 0 2px 10px;
  font-size: 14px;
  color: #333;
  line-height: 1.5;
}

/* 手机窄屏：菜单与内容上下留白收紧 */
@media (max-width: 640px) {
  .nav-container {
    margin: 8px;
  }

  .sidebar ul li {
    padding: 10px 8px;
    font-size: 13px;
  }

  .content {
    padding: 10px;
  }

  .childmain .parentName {
    font-size: 15px;
  }
}
</style>
